<template>
  <button
    class="app-checkbox"
    :class="{
      'is-checked': isChecked,
      'is-top': isTop,
      'is-padding': setPadding
    }"
    @click="clicked"
  >
    {{ label }}
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    }, // ボタンラベル
    isChecked: {
      type: Boolean,
      required: true,
      default: false
    }, // チェック状態
    isTop: {
      type: Boolean,
      required: false,
      default: false
    }, // チェックボックスの表示位置
    setPadding: {
      type: Boolean,
      required: false,
      default: false
    }, // チェックボックス自体を広げる（現状、こだわり条件モーダル内のみ）
  },
  methods: {
    clicked() {
      this.$emit('clicked')
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.app-checkbox {
  background-color: $white;
  color: $black;
  cursor: pointer;
  display: block;
  font-family: inherit;
  padding: 0 .5rem 0 1.75rem;
  position: relative;
  text-align: left;
  width: 100%;

  @include hover {
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  &::before {
    background-color: $white;
    border: 1px solid $cool-gray-3;
    border-radius: 0.25rem;
    content: '';
    display: block;
    height: 1.25rem;
    left: 0;
    position: absolute;
    top: calc(50% - 11px);
    width: 1.25rem;
  }

  &.is-checked {
    &::after {
      border-bottom: 3px solid $red;
      border-right: 3px solid $red;
      content: '';
      display: block;
      height: 14px;
      left: 6px;
      position: absolute;
      top: calc(50% - 10px);
      transform: rotateZ(45deg);
      width: 8px;
    }
  }

  &.is-top {
    &::before {
      top: 0;
    }

    &.is-checked {
      &::after {
        top: 1px;
      }
    }
  }

  &.is-padding {
    padding: 1rem 1.5rem 1rem 2.75rem;

    &::before {
      left: 1rem;
      top: calc(50% - 11px);
    }

    &.is-checked {
      &::after {
        left: calc(6px + 1rem);
        top: calc(50% - 10px);
      }
    }

    &.is-top {
      &::before {
        top: 1rem;
      }

      &.is-checked {
        &::after {
          top: calc(1px + 1rem);
        }
      }
    }
  }
}
</style>